import { Col, Row } from 'antd'
import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from "../../App.js";
import konsole from '../../network/konsole.js';
import Services from '../../network/Services';
import commonLib from '../../control/commonLib';
import "./communication.css"
import { Addcommunicationmodal } from './CommunicationModal/Addcommunicationmodal'
import Newmodal from './CommunicationModal/Newmodal'
import Communicationtable from './Communicationtable';


const Communication = ({ isOn, setIsOn, ...props }) => {

    const [showAddModal, setShowAddModal] = useState(false)
    const [GetCommMediumData, setCommMediumData] = useState([]);
    const [showCabinetModal, setShowCabinetModal] = useState(false);
    const [search, setSearch] = React.useState('');
    const { setLoader } = useContext(UserContext)
    const [subtenantID, setSubtenantID] = useState()
    const [emptyState, setEmptyState] = useState()


    useEffect(() => {
        let subtenantIDd = commonLib.getSessionStoarge("subtenantId")
        setSubtenantID(subtenantIDd)
        GetCommMediumPathApiFuction()

    }, [subtenantID])

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

konsole.log("propsprops",props)
konsole.log("kktttttkkk",subtenantID)


    const handleClose = () => {
        setEmptyState({})
        setShowAddModal(false);
    }

    const addEditModalFun = () => {
        setShowAddModal(true)

    }

    const GetCommMediumPathApiFuction = () => {
        let subtenantIDd = sessionStorage.getItem("subtenantId")
        // alert(subtenantIDd)
        // konsole.log("jjjjjjj",subtenantID)
        setLoader(true)
        const promises = Services.GetCommMediumPathApi(subtenantIDd)
        promises.then((response) => {
            konsole.log("GetCommMediumPakjkthApi", response?.data?.data);


            setCommMediumData(response.data.data);
            setEmptyState({})

            setLoader(false)
            // window.location.reload()
        })
            .catch((error) => {
                konsole.log("error", error);
                setLoader(false)
            })
            .finally(() => {
                konsole.log("finish");
            });
    };

    // setTimeout(() => {
    //     setLoader(false)
    // }, 3000)

    konsole.log("GetCommMediumPa;j;j;j;thApi", GetCommMediumData);
    konsole.log("subtenantID", subtenantID)


    return (
        <div>
            <Row >
                <Col span={24}>
                    <Row >
                        <Col span={24} >
                            {/* <h2>Communication</h2> */}
                        </Col>
                    </Row>
                <Row gutter={[32, 8]} align="middle" className="" style={{paddingTop:"15px"}}>
                <Col flex="auto">
                    <div
                        style={{
                            display: "flex",
                            border: "1px solid #474747",
                            height: "44px",
                            alignItems: "center",
                            borderRadius: "2px"}}>
                            <img className="ms-2"
                            style={{ padding: "2px", height: "20px", marginRight: "2px", marginLeft: "4px" }} src="/search icon.png" />
                            <input
                                className="form-control newInput searchBox"
                                style={{ border: "none", outline: "none", flex: 1, height: "100%", borderRadius: "2px"}}
                                type="text"
                                placeholder="Search for occurrences"
                                onChange={handleSearch}
                            />
                        </div>
                </Col>

                <Col flex="none" className='pe-0'>
                    <div
                        style={{
                            display: "inline-flex",
                            backgroundColor: "#e8e8e8",
                            borderRadius: "2px",
                            height:"44px",
                            padding: "4px",
                            gap: "2px"}}>
                        <button
                            onClick={() => setIsOn(false)}
                            style={{
                                padding: "6px 10px",
                                borderRadius: "1.5px",
                                border: "none",
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "14px",
                                backgroundColor: !isOn ? "#6e0f21" : "transparent",
                                color: !isOn ? "#fff" : "#444"}}>
                            Communication
                        </button>

                                <button
                            onClick={() => setIsOn(true)}
                            style={{
                                padding: "6px 10px",
                                borderRadius: "1.5px",
                                border: "none",
                                cursor: "pointer",
                                fontWeight: "noraml",
                                fontSize: "14px",
                                backgroundColor: isOn ? "#6e0f21" : "transparent",
                                color: isOn ? "#fff" : "#444"}}>
                            Content
                        </button>
                    </div>
                </Col>

                {/* Add Button */}
                <Col flex="none">
                    <button style={{ fontWeight: "bold", fontSize: "14px"}} className="Add-Edit-btn text-white" type="submit" onClick={addEditModalFun}>
                                    ADD
                                </button>
                            </Col>
                            {
                                showAddModal &&

                            <Addcommunicationmodal showAddModal={showAddModal} setShowAddModal={setShowAddModal} GetCommMediumPathApiFuction={GetCommMediumPathApiFuction} />
                            }
                    </Row>
                    {/* <Newmodal showAddModal={showAddModal} setShowAddModal={setShowAddModal}/> */}
                    <Row className='mt-2'>
                        <Col span={24}>

                            <Communicationtable search={search} GetCommMediumData={GetCommMediumData} GetCommMediumPathApiFuction={GetCommMediumPathApiFuction} />
                        </Col>
                    </Row>

                </Col>
            </Row>
        </div>
    )
}

export default Communication